import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface RevenueSourcesChartProps {
  data?: Array<{
    specialty: string;
    revenue: number;
  }>;
  className?: string;
}

const RevenueSourcesChart: React.FC<RevenueSourcesChartProps> = ({
  data = [
    { specialty: "Orthopedics", revenue: 120 },
    { specialty: "Neurology", revenue: 95 },
    { specialty: "Oncology", revenue: 78 },
  ],
  className = "",
}) => {
  return (
    <Card
      className={className}
      sx={{
        boxShadow: "none",
        border: "1px solid #d1d5db", // border-gray-300 equivalent
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          className="text-lg font-medium text-gray-600 mb-4"
        >
          Revenue Sources
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 20, right: 30, left: 100, bottom: 5 }}
          >
            <YAxis
              dataKey="specialty"
              type="category"
              width={100}
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 14, fill: "#374151" }}
            />
            <XAxis type="number" hide={true} />
            <Tooltip />
            <Bar dataKey="revenue" fill="#1e40af" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default RevenueSourcesChart;
